import { faFileExcel } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'
import {
  Button,
  ButtonVariation
} from '~/components/Global/Interactions/Button'
import { useCollectionExport } from '~/hooks/useCollectionExport'

type ExportListButtonProps = {
  resourceKey: string
  filename: string
  params: URLSearchParams
}

export const ExportListButton = ({
  resourceKey,
  filename,
  params
}: ExportListButtonProps): ReactElement => {
  const { exportCollection, isExporting } = useCollectionExport({
    resourceKey,
    filename
  })

  return (
    <Button
      type="button"
      buttonSize="small"
      variation={ButtonVariation.Neutral}
      disabled={isExporting}
      onClick={() => {
        void exportCollection(params)
      }}
    >
      <FontAwesomeIcon icon={faFileExcel} /> Exporter
    </Button>
  )
}
